
import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";

export async function updateEmployee(
  _id: string,
  updatedEmployee: any
): Promise<any> {
  try {
    const response = await axiosInstance.patch(
      `${config.apiUrl}/auth/update-employee/${_id}`,
      updatedEmployee
    );
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data.message || "Error updating Employee"
      );
    } else {
      throw new Error("An unknown error occurred");
    }
  }
}
